/* Layout */
import Layout from '../../views/layout/Layout.vue'

const RewardsnapPayoutMain = () => import(/* webpackChunkName: "rewardsnap-payout" */ '@/views/rewardsnap/payout/index')
const RewardsnapPayoutOrderPaymentStatusUpload = () => import(/* webpackChunkName: "rewardsnap-payout" */ '@/views/rewardsnap/OrderPaymentStatusUploadHistory')
const RewardsnapPayoutCampaignPaymentStatusUpload = () => import(/* webpackChunkName: "rewardsnap-payout" */ '@/views/rewardsnap/campaign/CampaignPaymentStatusUploadHistory')
const RewardsnapPayoutDownloadUpcomingPayout = () => import(/* webpackChunkName: "rewardsnap-payout" */ '@/views/rewardsnap/PendingPayment')
const RewardsnapCampaignPaymentList = () => import(/* webpackChunkName: "rewardsnap" */ '@/views/rewardsnap/campaign/CampaignPaymentList')

export default [
  {
    path: '/rewardsnap',
    component: Layout,
    redirect: 'noredirect',
    name: 'rewardsnap',
    alwaysShow: true,
    meta: {
      title: 'rewardsnap',
      icon: 'camera',
    },
    children: [
      {
        path: 'payout',
        component: RewardsnapPayoutMain,
        redirect: 'noredirect',
        name: 'rewardsnapPayoutMain',
        alwaysShow: true,
        meta: {
          title: 'rewardsnapPayoutMain',
          icon: 'money-bill',
        },
        children: [
          {
            path: 'order-payment-status-upload',
            component: RewardsnapPayoutOrderPaymentStatusUpload,
            name: 'rewardsnapPayoutOrderPaymentStatusUpload',
            meta: {
              title: 'rewardsnapPayoutOrderPaymentStatusUpload',
              icon: 'upload',
              accessibleName: 'rewardsnap-payout',
            },
          },
          {
            path: 'campaign-payment-status-upload',
            component: RewardsnapPayoutCampaignPaymentStatusUpload,
            name: 'rewardsnapPayoutCampaignPaymentStatusUpload',
            meta: {
              title: 'rewardsnapPayoutCampaignPaymentStatusUpload',
              icon: 'upload',
              accessibleName: 'rewardsnap-payout',
            },
          },
          {
            path: 'pending-payment',
            component: RewardsnapPayoutDownloadUpcomingPayout,
            name: 'rewardsnapPayoutDownloadUpcomingPayout',
            meta: {
              title: 'rewardsnapPayoutDownloadUpcomingPayout',
              icon: 'download',
              accessibleName: 'rewardsnap-payout',
            },
          },
        ],
      },
      {
        path: 'campaign-payment-list',
        component: RewardsnapCampaignPaymentList,
        name: 'rewardsnapCampaignPaymentList',
        meta: {
          title: 'rewardsnapCampaignPaymentList',
          icon: 'money-bill',
          accessibleName: 'rewardsnap',
        },
      },
    ],
  },
]
